require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-introducing-holly-francis.json") })
        }
      }, "path---authors-introducing-holly-francis");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-introducing-holly-francis!./.cache/json/authors-introducing-holly-francis.json
// module id = 1290
// module chunks = 231608221292675